// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AllocationFactory } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/AllocationFactory';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useBridgeFactory: () => UseQueryResult<
  TemplateContract<AllocationFactory>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { bridgeOperator } = useParties();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryBridgeFactory', offset, ledgerApi, bridgeOperator],
    queryFn: async () => {
      return ledgerApi.queryBridgeFactories(offset!, bridgeOperator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useBridgeFactory;
